import { render, staticRenderFns } from "./TheLibraryBookPage.vue?vue&type=template&id=7b89a90c&"
import script from "./TheLibraryBookPage.vue?vue&type=script&lang=js&"
export * from "./TheLibraryBookPage.vue?vue&type=script&lang=js&"
import style0 from "./TheLibraryBookPage.vue?vue&type=style&index=0&id=7b89a90c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports